// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JHb7W","navigation":"Button_navigation__WG6Q-","span":"Button_span__-BjXT","clear":"Button_clear__fAaR2"};